import classNames from "classnames";
import TruncateableContent from "@/components/activitystreams/activity/TruncateableContent.tsx";

type ActivityNoteArgs = {
  content?: string;
  className?: string;
  truncateLength?: number;
  translated?: boolean;
  showMoreButton?: boolean;
};

export default function ActivityNote({
  content,
  className,
  showMoreButton = true,
  truncateLength = 600,
  translated = false,
}: ActivityNoteArgs) {
  return (
    <TruncateableContent
      content={content}
      truncateLength={truncateLength}
      translated={translated}
      showMoreButton={showMoreButton}
      className={classNames(
        "note-view markdown-content prose break-words",
        className,
      )}
    />
  );
}
